import React from "react";

const WhatsAppIcon = ({
  size = 24,
  color = "#222222",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M13.5714 2.35714C15.0714 3.85714 16 5.82143 16 7.96429C16 12.3214 12.3571 15.8929 7.96429 15.8929C6.64286 15.8929 5.35714 15.5357 4.17857 14.9286L0 16L1.10714 11.8929C0.428571 10.7143 0.0357143 9.35714 0.0357143 7.92857C0.0357143 3.57143 3.60714 0 7.96429 0C10.1071 0 12.1071 0.857143 13.5714 2.35714ZM7.96429 14.5357C11.6071 14.5357 14.6429 11.5714 14.6429 7.96429C14.6429 6.17857 13.8929 4.53571 12.6429 3.28571C11.3929 2.03571 9.75 1.35714 8 1.35714C4.35714 1.35714 1.39286 4.32143 1.39286 7.92857C1.39286 9.17857 1.75 10.3929 2.39286 11.4643L2.57143 11.7143L1.89286 14.1429L4.39286 13.4643L4.60714 13.6071C5.64286 14.2143 6.78571 14.5357 7.96429 14.5357ZM11.6071 9.60714C11.7857 9.71429 11.9286 9.75 11.9643 9.85714C12.0357 9.92857 12.0357 10.3214 11.8571 10.7857C11.6786 11.25 10.8929 11.6786 10.5357 11.7143C9.89286 11.8214 9.39286 11.7857 8.14286 11.2143C6.14286 10.3571 4.85714 8.35714 4.75 8.25C4.64286 8.10714 3.96429 7.17857 3.96429 6.17857C3.96429 5.21429 4.46429 4.75 4.64286 4.53571C4.82143 4.32143 5.03571 4.28571 5.17857 4.28571C5.28571 4.28571 5.42857 4.28571 5.53571 4.28571C5.67857 4.28571 5.82143 4.25 6 4.64286C6.14286 5.03571 6.57143 6 6.60714 6.10714C6.64286 6.21429 6.67857 6.32143 6.60714 6.46429C6.25 7.21429 5.82143 7.17857 6.03571 7.53571C6.82143 8.85714 7.57143 9.32143 8.75 9.89286C8.92857 10 9.03572 9.96429 9.17857 9.85714C9.28572 9.71429 9.67857 9.25 9.78572 9.07143C9.92857 8.85714 10.0714 8.89286 10.25 8.96429C10.4286 9.03572 11.3929 9.5 11.6071 9.60714Z"
        fill={color}
      />
    </svg>
  );
};

export default WhatsAppIcon;
